import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { display } from 'state/modules/dialog';

// Global notification handler that works with notification middleware to display notifications
export class NotificationManager extends PureComponent {
  static propTypes = {
    display: PropTypes.func.isRequired,
    notifications: PropTypes.array.isRequired,
    intl: PropTypes.object.isRequired,
  };

  componentDidUpdate(prevProps) {
    const { notifications, intl: { formatMessage }, display } = this.props;
    if (notifications.length !== prevProps.notifications.length) {
      const latestNotification = notifications[notifications.length - 1];
      const notificationType = latestNotification?.notificationType ?? 'success';
      const body = latestNotification.messages ?
        latestNotification.messages.map(m => formatMessage({ id: m.id }, m.values)).join('\n')
        : formatMessage({ id: latestNotification.messageId }, latestNotification.values);
      display(
        formatMessage({ id: latestNotification?.titleId ?? `notifications.title.${notificationType}` }),
        body,
        notificationType,
        latestNotification?.closeAction
      );
    }
  }

  render() {
    return null;
  }
}

const ConnectedNotificationManager = connect(state => ({ notifications: state.notifications }), { display })(NotificationManager);

const NotificationManagerWithIntl = props => {
  const intl = useIntl();
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ConnectedNotificationManager {...props} intl={intl} />;
};

export default NotificationManagerWithIntl;
